import React from "react";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { connect } from "react-redux";
import { get, size, filter, includes, isEmpty } from "lodash";
import Box from "@material-ui/core/Box";

import OverrideDialogForm from "../OverrideDialogForm";
import DropdownButton from "../../Common/DropdownButton";
import images from "../../../assets/img/images";
import colors from "../../../assets/style/colors";

const styles = {
  plusIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  dialogRoot: {
    zIndex: "800 !important",
  },
  dialog: {
    width: "350px",
    maxHeight: "calc(100vh - 60px)",
    minHeight: "430px",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingRight: "12px",
    "& img": {
      cursor: "pointer",
    },
  },
  dialogTitle: {
    fontSize: "1.142em",
    color: colors.black87,
    textAlign: "center",
    textTransform: "uppercase",
  },
  buttonsContainer: {
    borderTop: `1px solid ${colors.black23}`,
    height: "65px",
  },
};

const AddDetection = (props) => {
  const { classes, siteEntranceExit, dac, refreshLogDetails, section } = props;
  const [open, setOpen] = React.useState(false);
  const [detectionType, setDetectionType] = React.useState();
  const [profileDetectionType, setProfileDetectionType] = React.useState();
  const [currentProfile, setCurrentProfile] = React.useState()
  const openDialog = () => setOpen(true);
  const closeDialog = () => setOpen(false);

  const selectDetection = (opt) => {
    setDetectionType(get(opt, ["typeId"]));
    setProfileDetectionType(
      get(opt, ["typeId"]) == 1 ? "driver" : get(opt, ["name"])
    );
    let response = filter(
      get(dac, ["events"]),
      (e) =>
        includes([60, 61], get(e, ["type", "id"])) &&
        get(e, ["active"]) &&
        get(e, ["profile", "type", "id"]) == get(opt, ["typeId"])
    );
    if (response.length > 0) {
      setCurrentProfile(get(response[0], ["profile"]));
    }
    openDialog();
  };

  let overrideAttributes = [];
  if (detectionType === 1) {
    if (
      size(
        filter(
          get(dac, ["events"]),
          (e) =>
            includes([60, 61], get(e, ["type", "id"])) && get(e, ["active"]) === true &&
            get(e, ["profile", "type", "id"]) === 1
        )
      ) > 0
    ) {
      overrideAttributes.push({
        id: 102,
        value: false,
      });
    } else {
      overrideAttributes.push({
        id: 102,
        value: true,
      });
    }
  } else if (includes([3, 4], detectionType)) {
    if (
      size(
        filter(
          get(dac, ["events"]),
          (e) =>
            includes([60, 61], get(e, ["type", "id"])) && get(e, ["active"]) === true &&
            get(e, ["profile", "type", "id"]) === detectionType
        )
      ) > 0
    ) {
      overrideAttributes.push({
        id: 121,
        value: 2,
      });
    } else {
      overrideAttributes.push({
        id: 121,
        value: 1,
      });
    }
  }

  const details = {
    dacId: get(dac, ["id"]),
    detectionId: null,
    handleProfileOverride: () => {
      closeDialog();
      refreshLogDetails();
    },
    fr: [],
  };

  if (detectionType === 3) {
    let tab = get(
      filter(
        get(siteEntranceExit, [section, "tabs"]),
        (t) => t.eventGroupId === get(dac, ["id"])
      ),
      [0, "data", "detections", "truck"]
    );
    if (!isEmpty(tab)) {
      details.truckImages = {
        contextPhotos: get(tab, ["contextPhotos"]),
        ocr: get(tab, ["ocr"]),
        lpr: get(tab, ["lpr"]),
      };
      details.truckDetectionEventGroup = tab;
    }
  }

  let options = [];
  if (
    size(
      filter(
        get(dac, ["events"]),
        (e) =>
          includes([60, 61], get(e, ["type", "id"])) && get(e, ["active"]) === true &&
          get(e, ["profile", "type", "id"]) === 1
      )
    ) === 0
  ) {
    options.push({
      name: "driver",
      typeId: 1,
      element: I18n.get("site_driver2"),
      startIcon: images.humanIconBlack,
    });
  }
  options.push({
    name: "passenger",
    typeId: 1,
    element: I18n.get("site_passenger"),
    startIcon: images.humanIconBlack,
  });
  if (
    size(
      filter(
        get(dac, ["events"]),
        (e) =>
          includes([60, 61], get(e, ["type", "id"])) && get(e, ["active"]) === true &&
          get(e, ["profile", "type", "id"]) === 3
      )
    ) < 2
  ) {
    options.push({
      name: "trailer",
      typeId: 3,
      element: I18n.get("site_trailer"),
      startIcon: images.trailerIconBlack,
    });
  }
  if (
    size(
      filter(
        get(dac, ["events"]),
        (e) =>
          includes([60, 61], get(e, ["type", "id"])) && get(e, ["active"]) === true &&
          get(e, ["profile", "type", "id"]) === 4
      )
    ) < 2
  ) {
    options.push({
      name: "container",
      typeId: 4,
      element: I18n.get("site_container"),
      startIcon: images.containerIconBlack,
    });
  }

  return (
    <>
      <DropdownButton
        triggerNode={
          <Box className={classes.plusIcon}>
            <img
              src={images.plusIconColored}
              alt="plus"
              style={{ marginRight: "5px" }}
            />
          </Box>
        }
        style={{
          display: "flex",
          alignItems: "center",
          margin: "0 20px",
        }}
        callback={selectDetection}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        options={options}
      />
      <OverrideDialogForm
        open={open}
        closeDialog={closeDialog}
        profileType={profileDetectionType}
        currentProfile={currentProfile}
        details={details}
        language={props.language}
        addNote={props.addNote}
        photos={[]}
        lov={props.lov}
        overrideAttributes={overrideAttributes}
        siteId={props.siteId}
        zoneId={props.zoneId}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["language"]),
    siteEntranceExit: get(state, ["siteEntranceExit"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(AddDetection));
